import React from 'react';
import { checkoutUrl } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'lg' | 'md';
  /** 'checkout' opens the external checkout, 'scroll' jumps to the pricing block on this page. */
  target?: 'checkout' | 'scroll';
  className?: string;
}
export function CtaButton({
  children,
  size = 'lg',
  target = 'checkout',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-3.5 text-base sm:text-xl md:px-8 md:py-5 md:text-2xl' : 'px-5 py-3.5 text-base sm:px-6 sm:py-4 sm:text-lg md:text-xl';
  const styles = `cta-pulse group inline-flex w-full max-w-2xl items-center justify-center rounded-lg bg-accent font-display font-extrabold uppercase tracking-wide text-white shadow-[0_10px_0_0_#b3121f] transition-[transform,box-shadow,background-color] duration-150 ease-snap hover:bg-[#f02334] hover:-translate-y-0.5 hover:shadow-[0_12px_0_0_#b3121f] active:translate-y-1.5 active:shadow-[0_2px_0_0_#b3121f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold ${sizing} ${className}`;
  if (target === 'scroll') {
    return <a href="#pricing" className={styles} data-id="element-52" data-mp="3exkrp5yezjj6">
        {children}
      </a>;
  }
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Baseball 360 — Complete Vault',
      value: 27,
      currency: 'USD'
    });
  };
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={styles} data-id="element-53" data-mp="3sxdif19xxzr5">
      {children}
    </a>;
}